import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-center mb-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "pr-8" }
const _hoisted_5 = { class: "pr-8" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { class: "pt-8" }
const _hoisted_14 = { class: "my-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mr-2" }
const _hoisted_17 = { class: "grey--text mr-2" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "grey--text mr-2" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "grey--text mr-2" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isFetching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_breadcrumbs, {
            class: "px-0",
            items: _ctx.breadcrumbs
          }, null, 8, ["items"]),
          _createElementVNode("div", null, [
            (_ctx.isUpdating)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "my-8"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.thisClass)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.thisClass.className), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.date), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.isApproved || _ctx.isApprovedByChief)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_v_chip, {
                      color: "primary",
                      dark: ""
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("承認済み", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : (_ctx.applicationStatus === 'applied')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_v_chip, {
                        color: "primary",
                        variant: "outlined",
                        dark: ""
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("申請済み", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createVNode(_component_v_chip, {
                        color: "grey",
                        variant: "outlined",
                        dark: ""
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("下書き", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
            ]),
            _createVNode(_component_v_spacer),
            (!_ctx.isApproved)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  variant: "flat",
                  color: "primary",
                  large: "",
                  class: "ml-2",
                  disabled: _ctx.isUpdating,
                  onClick: _ctx.saveAsDraft
                }, {
                  default: _withCtx(() => [
                    (_ctx.isDraft)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "下書きとして保存"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, "差戻し"))
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isDraft)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  variant: "flat",
                  color: "primary",
                  large: "",
                  class: "ml-2",
                  disabled: _ctx.isUpdating || _ctx.appliedBy === null,
                  onClick: _ctx.saveAndApply
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("申請", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            ((_ctx.isDirector || _ctx.isChief) && _ctx.isApplied)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    color: "primary",
                    large: "",
                    class: "ml-2",
                    disabled: _ctx.isUpdating || _ctx.isApprovedByMe,
                    onClick: _ctx.approve
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("承認", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              : _createCommentVNode("", true),
            (
            (_ctx.isChief && _ctx.isApplied && _ctx.isApprovedByChief) ||
            (_ctx.isDirector && _ctx.isApplied && _ctx.isApproved)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    color: "error",
                    large: "",
                    class: "ml-2",
                    disabled: _ctx.isUpdating,
                    onClick: _ctx.reject
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("承認取り消し", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: "施設長",
                    readonly: "",
                    variant: "outlined",
                    "model-value": _ctx.directorApproveStamp
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: "主任",
                    readonly: "",
                    variant: "outlined",
                    "model-value": _ctx.cheifApproveStamp
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    variant: "outlined",
                    label: "申請者",
                    items: _ctx.staffOptions,
                    "item-value": "userId",
                    "item-title": "name",
                    modelValue: _ctx.appliedBy,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appliedBy) = $event))
                  }, null, 8, ["items", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mb-2" }, "ねらい", -1)),
                  _createVNode(_component_v_textarea, {
                    readonly: _ctx.isApproved || _ctx.isApplied,
                    variant: "outlined",
                    modelValue: _ctx.aim,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.aim) = $event))
                  }, null, 8, ["readonly", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col)
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "mb-2" }, "活動内容: 午前", -1)),
                  _createVNode(_component_v_textarea, {
                    readonly: _ctx.isApproved || _ctx.isApplied,
                    variant: "outlined",
                    modelValue: _ctx.activityAm,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activityAm) = $event))
                  }, null, 8, ["readonly", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "mb-2" }, "活動内容: 午後", -1)),
                  _createVNode(_component_v_textarea, {
                    readonly: _ctx.isApproved || _ctx.isApplied,
                    variant: "outlined",
                    modelValue: _ctx.activityPm,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activityPm) = $event))
                  }, null, 8, ["readonly", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "mb-2" }, "反省と評価", -1)),
                  _createVNode(_component_v_textarea, {
                    readonly: _ctx.isApproved || _ctx.isApplied,
                    variant: "outlined",
                    modelValue: _ctx.assessment,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.assessment) = $event))
                  }, null, 8, ["readonly", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "mb-2" }, "保護者支援", -1)),
                  _createVNode(_component_v_textarea, {
                    readonly: _ctx.isApproved || _ctx.isApplied,
                    variant: "outlined",
                    modelValue: _ctx.support,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.support) = $event))
                  }, null, 8, ["readonly", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", _hoisted_14, " クラス内の園児記録 " + _toDisplayString(_ctx.childReportList ? _ctx.childReportList.length + "人" : ""), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childReportList, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                key: i,
                class: "px-6 py-6 my-3",
                flat: "",
                variant: "outlined"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              (item.attendance && item.attendance.status == 'isAbsent')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                    _createVNode(_component_v_chip, {
                                      color: "red",
                                      variant: "outlined"
                                    }, {
                                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createTextVNode("おやすみ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_table, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (header) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                          key: header.value,
                                          style: {"width":"14%"}
                                        }, _toDisplayString(header.text), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.child.lastName + item.child.firstName), 1)
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.report.sleeps, (sleep) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: sleep.sleepId
                                          }, _toDisplayString(sleep ? _ctx.formatDate(sleep.from) : "") + " ~ " + _toDisplayString(sleep ? _ctx.formatDate(sleep.to) : ""), 1))
                                        }), 128))
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.report.temperatures, (temperature) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: temperature.temperatureId
                                          }, [
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(temperature
                                  ? _ctx.formatDate(temperature.recordedAt)
                                  : ""), 1),
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(temperature
                                  ? _ctx.formatTemperature(temperature.temperature)
                                  : "") + "℃ ", 1)
                                          ]))
                                        }), 128))
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.report.defecations, (defecation) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: defecation.defecationId
                                          }, [
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(defecation
                                  ? _ctx.formatDate(defecation.recordedAt)
                                  : ""), 1),
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(defecation
                                  ? _ctx.formatDefecation(defecation.state)
                                  : ""), 1)
                                          ]))
                                        }), 128))
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.report.milks, (milk) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: milk.milkId
                                          }, [
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(milk ? _ctx.formatDate(milk.recordedAt) : ""), 1),
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(milk.amount ? milk.amount.value : "（不明）") + "cc ", 1)
                                          ]))
                                        }), 128))
                                      ]),
                                      (item.meal)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                                            _createElementVNode("div", null, [
                                              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "grey--text mr-2" }, "主菜", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.stapleFood)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "grey--text mr-2" }, "副菜1", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.mainDish)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "grey--text mr-2" }, "副菜2", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.sideDish)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "grey--text mr-2" }, "汁もの", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.soup)), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.meal)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                            _createElementVNode("div", null, [
                                              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "grey--text mr-2" }, "フルーツ", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.dessert)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "grey--text mr-2" }, "牛乳", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.milk)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "grey--text mr-2" }, "おやつ", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.formatMealStatus(item.meal.snack)), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, { class: "pt-3 px-3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            "model-value": item.diary?.content,
                            "auto-grow": "",
                            variant: "filled",
                            readonly: "",
                            label: "活動記録/発達状況",
                            "hide-details": ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_v_progress_linear, {
            indeterminate: "",
            color: "primary"
          })
        ]))
  ]))
}